export default __webpack_public_path__ + "static/media/logo-symbol.35848990.svg";